export enum LoginResultType {
  Ok = "Ok",
  Unknown = "Unknown",
  HasOpenExam = "HasOpenExam",
  InvalidUserNamePassword = "InvalidUserNamePassword",
  UserIsNotConfirmed = "UserIsNotConfirmed",
  Banned = "Banned",
  AlreadyLoggedIn = "AlreadyLoggedIn",
  CaptchaChallengeFailed = "CaptchaChallengeFailed",
  InvalidUserName = "InvalidUserName",
  LoggedInAnotherTab = "LoggedInAnotherTab",
  OldVersion = "OldVersion",
  INVALID_VERIFICATION_CODE = "INVALID_VERIFICATION_CODE",
  GRADE_IDS_NULL_IN_FINAL_REGISTRATION = "GRADE_IDS_NULL_IN_FINAL_REGISTRATION",
  MAJOR_IDS_NULL_IN_FINAL_REGISTRATION = "MAJOR_IDS_NULL_IN_FINAL_REGISTRATION",
  InvalidPassword = "InvalidPassword",
  InvalidPhoneNumber = "InvalidPhoneNumber",
  SuspendContract = "SuspendContract",
  BlockedUser = "BlockedUser",
  NOT_REGISTERED = "NOT_REGISTERED"
}

export enum UsersTypeEnum {
  STUDENT = 1, // دانش آموز
  ADVISOR = 2, // مشاور
  ADMINISTRATOR = 3, // ادمین
  DEAN = 4, // مدرسه
  OPERATOR = 5, // اپراتور
  AUTHOR = 6, // نویسنده
  OBSERVER = 7, // ناظر
  AGENT = 8, // مسئول
  TEACHER = 9, // دبیر
  SALES_MANAGER = 10, // مدیر فروش
  SALES_EXPERT = 11, // کارشناس فروش
  PARENT = 12, // والد
  SCHOOLOPERATOR = 13, // اپراتور مدرسه
  PRESENTER = 14, // نیروی صف
  آموزشگاه = 20, // آموزشگاه
  مرکز_مشاوره = 21, // مرکز مشاوره
  AM = 22, // مدير اکانت
  SDR = 23, // کارشناس توسعه فروش
  مدیر_مالی = 24, // مدیر مالی
  کارشناس_مالی = 25, // کارشناس مالی
  SUPER_USER = 26, // مجتمع
  PUBLISHER = 27, // انتشارات
  معاون_مدرسه = 28, // معاون مدرسه
  MARKETING_MANAGER = 29, // مدیر بازاریابی
  MARKETING = 30, // بازاریابی
  EXAM_MARKET_ADMIN = 31, //	ExamMarket Admin
  EXAM_MARKET_PROVIDER = 32 //	ExamMarket Provider
}

export enum RegistrationStateIdEnum {
  INITIALIZED = 10,
  COMPLETED = 20,
  INVALID = 30,
  UNPAID = 40
}

export enum CartRefTypes {
  EDUCATIONAL_PACK_PRODUCT = 1,
  EDUCATIONAL_PACK_CHAPTER = 2,
  QUESTION_BANK = 3
}

export enum CartProductTypes {
  QUESTION_BANK = 1,
  VIP = 2,
  MONTA_EXAM = 3,
  MONTA_ACADEMY = 4,
  ONLINE_CLASS = 5,
  ONLINE_EXAM = 6,
  PRINTABLE_EXAM = 7,
  AUTOMATION = 8,
  SMS_CHARGE = 10,
  EDUCATIONAL_PACK = 11
}

export enum BuyerTypeIds {
  SCHOOL = 4,
  STUDENT = 1,
  TEACHER = 9
}

export enum FeaturesEnum {
  PUBLIC_EXAM_FOR_TEACHER = "PUBLIC_EXAM_FOR_TEACHER",
  CHANGE_ACCOUNT_AFTER_LOGIN = "CHANGE_ACCOUNT_AFTER_LOGIN",
  DEPENDENT_USER_SUBMIT_PHONE_NUMBER = "DEPENDENT_USER_SUBMIT_PHONE_NUMBER"
}

export const GWTCodes = {
  CALLER: "a1",
  EXAM_REQUEST_ID: "a2",
  MAJOR_ID: "a3",
  GRADE: "a4",
  EXAM_NAME: "a5",
  STEP: "a6",
  IGNORE_PREPARE_FROM_REQUEST: "a7",
  EXAM_EDITOR: "a8",
  CREATED_BY: "a9",
  FIRST_BOOKLET_QUESTION_COUNT: "a10",
  SECOND_BOOKLET_QUESTION_COUNT: "a11",
  FIRST_BOOKLET_DURATION: "a12",
  SECOND_BOOKLET_DURATION: "a13",
  EXAM_OUTPUT_TYPE: "a14",
  EXAM_TOPICS: "a15",
  LOGIN: "a16",
  SIGN_UP: "a17",
  FORGOT_PASSWORD: "a18",
  SMS_AUTHENTICATION: "a19",
  PHONE_NUMBER: "a20",
  USER_ID: "a21",
  PRACTICE: "a22",
  SELF_EXAMINATION: "a23",
  EXAM_TAKING_ID: "a24",
  EXAM_PRICE: "a25",
  EXAM_TARGET_GROUP: "a26",
  EXAM_TAKING_GOAL_ID: "a27",
  EXAM_START_DATE_TIME: "a28",
  EXAM_TAKING_TYPE_ID: "a29",
  EXAM_END_DATE_TIME: "a30",
  PRICE_PER_QUESTION: "a31",
  EXAM_INFO: "a32",
  EXAM_ACCESS_TYPE_ID: "a34",
  SUBMITTED_QUESTION_DIFFICULLTYLEVEL: "a35",
  SUBMITTED_QUESTION_TOPIC: "a36",
  SUBMITTED_QUESTION_TAG: "a37",
  SUBMITTED_QUESTION_TYPE: "a38",
  QUESTION_COUNT: "a39",
  EXAM_REQUEST_TYPE_ID: "a40",
  EXAM_COST: "a41",
  TAKING_COUNT_WITH_CANCELS: "a42",
  EXAM_FREE_QUESTION_COUNT: "a43",
  EXAM_MODULE_INFO: "a44",
  IS_ANSWER_KEY_EDITING: "a45",
  EXAM_DURATION: "a46",
  CURRENT_PERIOD_ID: "a47",
  ABSENT_PARTICIPANT_NO: "a48",
  PRESENT_PARTICIPANT_NO: "a49",
  START_TAKING_DATE_TIME: "a50",
  EXAM_PARTICIPANT_NO: "a51",
  RECOVERY_UNCOMMITTED_CHANGES: "a52",
  CUSTOMER_ID: "a53",
  IS_ONLINE: "a54",
  CURRENT_PERIOD_NO: "a55",
  DIFFICULTY_LEVEL_ID: "difficultylevelid",
  IS_SHARED: "is_shared",
  SHARED_EXAM_INFO: "shared_exam_info",
  EXAM_COSTABLE_QUESTION_COUNT: "a66",
  isBought: "a67",
  EXAM_PAID_QUESTION_COUNT: "a68",
  SHOW_EXAM_OR_TAKING_TAB: "a69",
  IS_NON_MONTA: "a70",
  CUSTOMER_NAME: "a71",
  CONTRACT_ID: "a72",
  USER_OWNER_ID: "a73",
  CONTRACT_USER_ID: "a74",
  IS_STUDENT_ADS: "a75",
  IS_PREVIEW_MODE: "a76",
  TOPIC_ID: "a77",
  QUESTION_IMAGE_ID: "a78",
  AUTHOR_ID: "a79",
  IMAGE_NAME: "a80",
  PROFILE_NAME: "a81",
  DISCOUNT_LINK_ID: "a82",
  DISCOUNT_CONSUME_LINK_ID: "a83",
  ITEM_SELECTOR: "a84",
  PARENT_PACK_NAME: "a85",
  MODULE_ID: "a86",
  MONTH_NUM: "a87",
  IS_STUDENT_MODE: "a88",
  RANDOM_ID: "a90",
  IS_CUSTOME: "a91",
  PARTICIPANT_IDS: "a92",
  MODULE_IDS: "a93",
  SELECTED_MODULE_IDS: "a94",
  IS_DESCRIPTIVE: "a95",
  SUB_PACKAGE_ID: "a96",
  IS_DEMO: "a97",
  IS_NOTIFICATION: "a98",
  NOTIFICATION_QUESTION_ID: "a99",
  NOTIFICATION_SHOW_INVITATION_POPUP: "a100",
  IS_FOLLOW_REQ_NOTIFICATION: "a101",
  NOTIFICATION_ID: "a102",
  QUESTION_ID: "a103",
  MEDIA_ID: "a104",
  POST_ID: "a105",
  RESUME_TYPE: "a106",
  POPUP: "a107",
  INDEX: "a108",
  PROFILE_REPLACE_URL: "a109",
  USER_NAME: "a110",
  EDIT_ID: "a111",
  JOB_OPPORTUNITY_ID: "a112",
  HASHTAG_NAME: "a113",
  SEARCH_TEXT: "a114",
  EXAM_SERI_ID: "a115",
  EXAM_BOOKLET_TYPE: "a116",
  IS_RESULT_VIEWABLE: "a117",
  IS_PUBLISHER_USER_TYPE: "a118",
  PROFILE_IMAGE_ID: "a119",
  PUBLISHER_BOOK_ID: "a120",
  MEETING_SESSION_ID: "a121",
  IS_RECORDING: "a122",
  MODULE_TOPIC_JSON: "a123",
  SESSION_DETAIL_MANAGEMENT_ROLE_ID: "a124",
  BUNDLE_SUBTYPE_ID: "a125",
  PRODUCT_BUNDLE_ID: "a126",
  MAX_GRADE: "a127",
  IS_SINGLE_DESCRIPTIVE_ANSWER: "a128",
  EXAM_ID: "a129",
  HAS_MEDIA: "a130",
  HAS_MIXED_CHOICE_ORDER: "a131",
  HAS_MULTIPLE_QUESTION_ORDER: "a132",
  PLAN_CALENDAR_ID: "a133",
  IS_QUESTION_SOURCE_RELOAD_MODE: "a134",
  IS_VIEW_NONMONTA_EXAM_MODE: "a135",
  IS_SIMULATE_EXAM_FROM_REACT: "a136",
  ACTION: "a137",
  IS_SELECT_MODE: "a138",
  IS_PAYMENT_EDITION_MODE: "a139",
  PLAN_PUBLISH_ID: "a140",
  SERI_NAME: "a141",
  ANSWER_SHEET_SIZE: "a142",
  PRINT: "a143",
  POPUP_NAME: "a144",
  IS_MONTAZMOON: "a145",
  PIPELINE_ID: "a146",
  SDR_ID: "a147",
  AM_ID: "a148",
  IS_FROM_REACT_EXAM_MANAGEMENT: "a149",
  EDUCATION_PACK_ITEM_ID: "a200",
  TEMPLATE_TYPE_ID: "a201",
  IS_QUESTION_MODE_FOR_PRINT: "a202",
  ID_CONST: "id"
};
